import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import { postFetcher } from 'features/rolodex/fetchers'
import useSWR, { SWRConfiguration } from 'swr'
import { RolodexFilterType } from 'types'

export function useGetRolodexEntriesByLoadOptions<T>(
  loadOptions: {
    type?: string[]
    tags?: Record<string, string | string[]>
    filters?: RolodexFilterType[]
    advanced_filter?: {
      operator: 'and' | 'or'
      filters: RolodexFilterType[]
    }
    order_by?: Record<string, string>[]
    ids?: string[]
    limit?: number
  },
  swrConfig?: SWRConfiguration<T, Error>
) {
  const { authorizedAxios: axios } = useGeckoAuth()
  const { ROLODEX_URL } = useRuntimeVariables()
  const endpoint = `${ROLODEX_URL}/api/v2/entries/load`
  const bodyData = JSON.stringify(loadOptions)
  const { data, error, isLoading, isValidating, mutate } = useSWR<
    T,
    Error,
    [string, string]
  >(
    [endpoint, bodyData],
    ([endpoint, bodyData]) => postFetcher(endpoint, bodyData, axios),
    swrConfig
  )

  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  }
}

export function useGetRolodexAuditLog<T>(entryIDs: string[]) {
  const { authorizedAxios: axios } = useGeckoAuth()

  const body = JSON.stringify({
    entry_ids: entryIDs,
  })

  const { ROLODEX_URL } = useRuntimeVariables()
  const endpoint = `${ROLODEX_URL}/api/v2/audit-log/entries`
  const { data, error, isLoading, isValidating, mutate } = useSWR<
    T,
    Error,
    [string, string]
  >([endpoint, body], ([endpoint, body]) => postFetcher(endpoint, body, axios))

  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  }
}
